import { useEffect, useState } from "react";

import {
  ApiCallStatus,
  ApiEndpoints,
  ApiResponse,
  GenericApiValue,
  getApiClient,
} from "../api-http";
import { getApiLocale } from "../api-http/get-api-locale";

export function useGetGenericApiValues(
  locale: string,
  endpoint: ApiEndpoints
): [GenericApiValue[] | null, ApiCallStatus] {
  const [result, setResult] = useState<GenericApiValue[] | null>(null);
  const apiLang = getApiLocale(locale);
  const [status, setStatus] = useState<ApiCallStatus>(ApiCallStatus.LOADING);

  useEffect(() => {
    // I am in the browser
    getApiClient()
      .get<ApiResponse<GenericApiValue[]>>(endpoint, {
        headers: {
          "Accept-Language": apiLang,
        },
      })
      .then((response) => {
        setResult(response.data.data);
        setStatus(ApiCallStatus.SUCCESS);
      })
      .catch((e) => {
        console.log(e);
        setStatus(ApiCallStatus.FAILED);
      });
  }, [apiLang, endpoint]);

  return [result, status];
}
